var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-limit-selector"},[_c('SelectField',{attrs:{"value":_vm.value,"items":_vm.selectItems,"label":_vm.label,"floating-label":false},on:{"input":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }